// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2qB3e","actionsCol":"EnrolledClinics_actionsCol__1DPpl"};